import useUrlState from '@ahooksjs/use-url-state'
import { BellOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

import { AppHeader, ColumnLayout } from '@/components'
import { SingleGroupApply } from '@/modules/group/group-apply/group-single-apply.component'
import { GroupContainer } from '@/modules/group/group.container'
import { SinglePost } from '@/modules/post/single-post'
import { routes } from '@/routes'

import { OnClickParam } from './notification.component'
import s from './notification.module.less'

export const NotificationContainer = () => {
  const [t] = useTranslation()
  const history = useHistory()

  const [state] = useUrlState<OnClickParam>()

  const notificationSetting = (
    <Button type='primary' onClick={() => history.push(routes.notificationSettings.home())}>
      {t('notificationSetting.title')}
    </Button>
  )

  const header = (
    <AppHeader
      title={t('notification.notification')}
      avatar={<BellOutlined style={{ fontSize: 28 }} />}
      actions={notificationSetting}
    />
  )

  const placeholder = (title: string) => {
    return (
      <div className={s.placeholder}>
        <Typography.Title level={4} type='secondary'>
          {title}
        </Typography.Title>
      </div>
    )
  }

  let content = placeholder('详细信息')
  if (state) {
    switch (state.targetKind) {
      case 'post':
        content = <SinglePost postId={Number(state.targetId)} />
        break
      case 'request':
        content = <SingleGroupApply requestId={Number(state.targetId)} />
        break
      case 'group':
        // 整页替换
        return <GroupContainer groupId={Number(state.targetId)} />
      case 'user': {
        history.push(routes.users.page(state.targetId))
        break
      }
    }
  }

  const middle = <div className={s.container}>{content}</div>

  return <ColumnLayout header={header} middle={middle} />
}
